import { useAppSelector } from "../store/hooks";
import useCurrentResourceCentre from "./useCurrentResourceCentre";
import { ServiceInterface } from "../interfaces/ServiceInterface";

const useBookingDefaultService = (): { defaultServices: ServiceInterface[] } => {
  const rc = useCurrentResourceCentre();
  const { defaultService } = rc.settings?.bookingSettings || {};
  const services = useAppSelector((state) =>
    state.services.collection.filter((item: ServiceInterface) => item.active)
  );
  return {
    defaultServices: services.filter((item: ServiceInterface) => item.id === defaultService)
  };
};

export default useBookingDefaultService;
